
import styled from 'styled-components';
import COLORS from '@mlb/react-patterns/v4/style/universal.color.ts';
import Button from '@mlb/react-patterns/v4/components/Button/button';

const {
    liveBlue,
} = COLORS;

export const NoFeedWrapper = styled.li`
    color: var(--gameday-secondary-font-color);
`;

export const ButtonOverride = styled(Button)`
    &&& {
        padding:0;
        height: auto;
        margin: 0 4px 0 0;
        border-radius: 0;
        margin-top: -5px;
    }
`;

export const AudioWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    padding: 16px 16px;
    text-align: left;

    div {
        font-size: 18px;
        line-height: 18px;
        font-weight: 700;
        color: var(--gameday-primary-font-color);
    }

    ul {
        list-style-type: none;
        padding: 0;
        margin: 0;

        li {
            margin-top: 16px;
            font-size: 14px;
            line-height: 16px;
            a {
                color: var(--gameday-secondary-font-color);

                &:hover {
                    color: var(--gameday-audio-list-link-hover-color);
                }
            }
        }
    }
`;

export const WatchWrapper = styled(AudioWrapper)`
    padding-bottom:0
`;

export const VersionListWrapper = styled.div`
    font-size: 12px;
    line-height: 12px;
    padding: 16px 0px;
    margin: 0px 16px;
    border-top: 1px solid var(--gameday-divider-color);
    color: var(--gameday-primary-font-color);
    text-align: left;
    display: flex;
    flex-direction: row;
    font-weight: 500;
`;

export const VersionLabel = styled.div`
    width: 48px;
`;

export const VersionWrapper = styled.div`
    color: var(--gameday-secondary-font-color);
    text-transform: initial;
    dislplay: flex;
    &:nth-child(2) {
        margin-top: 2px;
    }
`;
